<template>
  <div class="lang-switcher">
    <select
      class="lang-select"
      :value="locale"
      :aria-label="t('lang.select')"
      @change="switchLang($event.target.value)"
    >
      <option v-for="opt in options" :key="opt.code" :value="opt.code">
        {{ opt.flag }} {{ opt.label }}
      </option>
    </select>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { setLocale } from '../i18n'

const FLAGS = {
  zh: '🇨🇳',
  en: '🇺🇸',
  lo: '🇱🇦',
  th: '🇹🇭',
}

export default {
  name: 'LanguageSwitcher',
  setup() {
    const { locale, t } = useI18n()

    const options = computed(() => [
      { code: 'zh', flag: FLAGS.zh, label: t('lang.zh') },
      { code: 'en', flag: FLAGS.en, label: t('lang.en') },
      { code: 'lo', flag: FLAGS.lo, label: t('lang.lo') },
      { code: 'th', flag: FLAGS.th, label: t('lang.th') },
    ])

    function switchLang(code) {
      setLocale(code)
    }

    return { locale, t, options, switchLang }
  },
}
</script>

<style scoped>
.lang-switcher {
  position: relative;
}

.lang-select {
  appearance: none;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.1)
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='white' d='M1 1l5 5 5-5'/%3E%3C/svg%3E")
    no-repeat right 0.55rem center;
  color: #fff;
  padding: 0.35rem 1.75rem 0.35rem 0.65rem;
  border-radius: 6px;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  min-width: 108px;
}

.lang-select:focus {
  outline: none;
  border-color: var(--color-accent);
  box-shadow: 0 0 0 2px rgba(13, 148, 136, 0.35);
}

.lang-select option {
  color: #1c2b26;
  background: #fff;
}

:global(.admin-page) .lang-select {
  border-color: var(--color-border);
  background-color: var(--color-surface);
  color: var(--color-text);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%235c7268' d='M1 1l5 5 5-5'/%3E%3C/svg%3E");
}
</style>
